
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';

// unidades
import moment from 'moment';
import { URL } from '../../variables';
import ReactPaginate from 'react-paginate';
import Tooltip from 'react-tooltip';
import { MdDelete, MdModeEdit, MdOutlineQuestionAnswer, MdQuestionAnswer, MdSearch } from 'react-icons/md';
import { Pagination } from '@material-ui/lab';
import { CircularProgress } from '@material-ui/core';
import { FaListAlt } from 'react-icons/fa';
import Search from '../ReusableComponents/Search';
import { BsFillEyeFill, BsGraphUp } from "react-icons/bs";
import { Button } from "react-bootstrap";
import DefaultButton from '../ReusableComponents/DefaultButton';
import { RiArrowGoBackLine } from 'react-icons/ri';
import ModalQuestao from '../CategoriasQuestoes/ModalQuestao';
import ModalRespostaRecurso from './ModalRespostaRecurso';
import { PreferencesContext } from '../../contexts/PreferencesContext';
import StatusBadge, { getAnswerStatus } from '../ReusableComponents/StatusBadge';
import WorkQueueItem from '../ReusableComponents/WorkQueueItem';

class Recursos extends Component {
    static contextType = PreferencesContext;

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: false,
            recursos: [],
            pagination: {
                page: 1,
                last_page: 1,
            },
            msgErro: '',
            show_warning: false,
            show_erro: false,
            unidade_to_delete: '',
            search: '',
            loading_search: true,
            questao:{},
            show_more:false
        };
    }






    componentDidMount() {

        this.get_recursos(this.state.page);
    }

    get_recursos(page, search = '', busca = true) {
        if (busca == true) {
            if (this.state.loading_search == false) {
                this.setState({ loading_search: true });
            }
        }
        else if (this.state.loading_screen === false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/professor/get_recursos/${this.props.match.params.id}?page=${page}&search=${search}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });
                }
                else {
                    this.setState({ loading_search: false, recursos: resp.recursos, loading_screen: false, pagination: resp.pagination,questao:resp.questao });
                }
            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);
            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }


    delete_recurso(id) {

        fetch(`${URL}api/faculdade/delete_recurso/${id}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ msgErro: erro, show_warning: false, show_erro: true });
                }
                else {
                    this.setState({ show_warning: false });
                    this.get_recursos(this.state.page, this.state.search);
                }




            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);


            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
            });
    }







    render() {
        return (
            <div className="appeals-list-page">
                {this.state.redirect == true && <Redirect to={this.state.path} />}
                {this.state.questao.id != undefined && <ModalQuestao showModal={this.state.show_more} setShowModal={(e) => this.setState({ show_more: e })} questao={this.state.questao} />}
                <ModalRespostaRecurso showModal={this.state.showModal} setShowModal={(e) => this.setState({ showModal: e })} questao_id={this.props.match.params.id} />

                <div className="appeals-context-bar">
                    <button type="button" className="appeals-question-button" onClick={() => this.setState({ show_more: true })}>
                        <span className="appeals-question-icon"><MdQuestionAnswer /></span>
                        <span>
                            <small>{this.context.t('question_singular')}</small>
                            <strong>{this.context.t('action_manage_question')}</strong>
                        </span>
                    </button>
                    <DefaultButton bg="secondary" text={this.context.t('action_back')} icon={<RiArrowGoBackLine />} to="/recursos" />
                </div>

                {this.state.loading_screen == false && <div className="appeals-list-content">
                    <div className="appeals-toolbar">
                        <Search placeholder={this.context.t('placeholder_search_resource')} ValueChange={value => {
                                                clearTimeout(this.pesquisarTimeout);
                                                this.pesquisarTimeout = setTimeout(() => {
                                                    let page = { ...this.state.pagination };
                                                    page.current_page = 1;
                                                    this.setState({ pagination: page, search: value, loading_search: true });
                                                    this.get_recursos(1, value);
                                                }, 500);
                                            }} />
                        <button type="button" className="appeals-reply-button" onClick={() => this.setState({ showModal: true })}>
                            <MdOutlineQuestionAnswer />
                            <span>{this.context.t('title_reply_resources')}</span>
                        </button>
                    </div>

                    <div className="work-queue work-queue-resources">
                        {this.state.loading_search == false && this.state.recursos.map((item) => (
                            <WorkQueueItem
                                key={item.id}
                                icon={<MdOutlineQuestionAnswer />}
                                eyebrow={this.context.t('title_resources')}
                                title={item.name}
                                meta={[{ label: this.context.t('label_deadline_datetime'), value: moment(item.data_limite).format('DD/MM/YYYY HH:mm') }]}
                                status={<StatusBadge {...getAnswerStatus(item.resposta != null)} />}
                                actions={<Link className="work-queue-action-button" to={`/recursos/show/${item.id}`}>
                                    <BsFillEyeFill />
                                    <span>{this.context.t('authorAppealDetailsTitle')}</span>
                                </Link>}
                            />
                        ))}
                    </div>

                    {this.state.loading_search == true && <div className="appeals-loading"><CircularProgress /></div>}
                    {this.state.loading_search == false && this.state.recursos.length == 0 && <div className="work-queue-empty">{this.context.t('empty_no_resources')}</div>}

                    <Pagination
                        className={(this.state.pagination.last_page == 1 ? "hide" : "")}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                        count={this.state.pagination.last_page}
                        value={this.state.pagination.current_page}
                        onChange={(_, value) => {
                            let page = { ...this.state.pagination };
                            page.current_page = value;
                            this.setState({ pagination: page });
                            this.get_recursos(value, this.state.search);
                        }}
                    />
                </div>}

                {this.state.loading_screen == true && <div className="appeals-loading"><CircularProgress /></div>}

                                    <SweetAlert
                                        warning
                                        title={this.context.t('legacy_atencao')}
                                        onConfirm={() => {
                                            this.setState({ show_warning: false, loading_search: true });
                                            this.delete_recurso(this.questao_id);
                                            // this.delete_banner(this.state.banner_to_delete);
                                        }}
                                        onCancel={() => {
                                            this.setState({ show_warning: false });
                                        }}
                                        show={this.state.show_warning}
                                        confirmBtnText={this.context.t('legacy_sim_desejo_apagar')}
                                        cancelBtnText={this.context.t('action_cancel')}
                                        confirmBtnBsStyle="success"
                                        cancelBtnBsStyle="danger"
                                        showCancel={true}
                                    >
                                        {this.context.t('confirm_delete_question')}
                                    </SweetAlert>
            </div>
        );
    }


}
const mapsStateToProps = (state) => (
    {
        user: state.AppReducer.user,
        token: state.AppReducer.token,
    }
);

export default connect(mapsStateToProps, { logout })(Recursos);
